import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=fdfd963e&scoped=true&"
import script from "./OrganizationList.vue?vue&type=script&lang=js&"
export * from "./OrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=fdfd963e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfd963e",
  null
  
)

/* custom blocks */
import block0 from "./OrganizationList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfd963e')) {
      api.createRecord('fdfd963e', component.options)
    } else {
      api.reload('fdfd963e', component.options)
    }
    module.hot.accept("./OrganizationList.vue?vue&type=template&id=fdfd963e&scoped=true&", function () {
      api.rerender('fdfd963e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganizationList.vue"
export default component.exports